<template>
    <v-container class="pt-0">
        <v-card :class="isMobile? 'pl-0 pr-0':'pl-4 pr-4'">
            <v-card-title primary-title><h2 :style="'color:' + theme.primary.base">Passenger Information</h2></v-card-title>
            <v-form>
                <Passenger :viewModels="viewModels" @emPassenger="p=>passengerEmitted(p)"
                    :passenger="passenger" 
                    :validationWatcher="validationWatcher"
                    v-for="(passenger, index) in passengers " :key="index"/>
            </v-form>
        </v-card>
    </v-container>
</template>

<script>
/* eslint-disable */
import Passenger from './Passenger'
import Helper from '../helper';
import Theme from '../../theme';

export default {
    props:["bookingPassengers","viewModels","validationWatcher"],
    components:{Passenger},
    computed:{
        isMobile(){
            return Helper.display.isMobile(this.$vuetify.breakpoint.name);
        },      
    },
    data(){
        return {
            passengers:this.bookingPassengers,
            contactPersonPassengerNo:0,
            theme:Theme,
            emitters:{
                dataForAjaxPost:"dataForAjaxPost",
                emPassengers:"emPassengers",
                emValidationPassed:"emValidationPassed",
            },
            contactPerson:null,
        }
    },
    created(){
        this.initializeViewModelData();
    },
    updated(){
        //this.buildDataForAjaxPost();
        this.emitPassengers();
    },
    methods:{
        checkValidations(){
            let lnqVals = new this.$linq(this.passengers);
            let vals = lnqVals.where (p=>p.validationPassed==false).toArray();
            //alert(vals[0].validationPassed);
            let hasInvalidity = lnqVals.any(p=>p.validationPassed==false);
            //alert("Validation " +hasInvalidity==false);
            this.$emit(this.emitters.emValidationPassed,hasInvalidity==false);
        },
        passengerEmitted(psng){
            this.aPassengerIsContactPerson(psng);
            this.emitPassengers();
        },
        emitPassengers(){
            this.checkValidations();
            this.$emit(this.emitters.emPassengers,this.passengers);
        },
        aPassengerIsContactPerson(psng){
            let contactPersonFound = false;
            let breakException = {};

            if (psng.isContactPerson){
                this.passengers.forEach(p=>{
                    if (psng!==p){
                        p.isContactPerson = false;
                    }
                })
            }

            try{
                this.passengers.forEach(p => {
                    contactPersonFound = p.isContactPerson; 
                    if (p.isContactPerson){
                        throw breakException
                    }
                });
            }catch(e){
                if (e!==breakException) throw e;
            }

            setTimeout(()=>{
                this.$emit("aPassengerIsContactPerson",contactPersonFound);
            },500);
        }, 
        initializeViewModelData(){
            this.passengers.forEach(p=>{
                p.title = "";
                p.firstName = "";
                p.middleName = "";
                p.lastName = "";
                p.fqFlyerProgramAirline = "";
                p.fqFlyerNo = "";
                p.meal = "";
                p.dobDay = "";
                p.dobMonth = "";
                p.dobYear = "";
                p.seatPreference = "";
                p.passportCountry;
                p.passportNo = "";
                p.passportExpirationDate = "";
                p.phoneNo = "";
                p.email = "";
                p.address= "";
                p.validationPassed=false;
            });
            this.contactPerson = {
                phoneNo:"",
                title:"",
                firstName:"",
                middleName: "",
                lastName:"",
                address:"",
                country:"",
                email:""
            };
        },
    }
}
</script>

<style>

</style>